import { db } from "../../../config/firebaseconfig";

/**
 * Gets all nodes and sends them to central store
 * @param {object} param1 gives loading, success, and error actions
 */
export default function getAllNodes ({loading, success, error}) {
  loading()
  return db.collection('knowledgeMapNodes').get()
    .then((querySnapshot) => {
      let nodes = {}
      querySnapshot.forEach((doc) => {
        const data = doc.data()
        if (!data.deleted) {
          nodes[data.id] = data
        }
      })
      success(nodes)
    })
    .catch((err) => error(err))
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentDashboard/getAllNodes.js